import React, { useEffect, useState, useRef } from 'react';
/**
 * TableReadingRenderer — Select a row from a data table.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s68.
 */

import { QuestionRendererProps } from './types';
import { LatexRenderer } from '../../../components/ui/LatexRenderer';
export function TableReadingRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const config = question.data || {};
  const table = config.table || {
    headers: [],
    rows: []
  };
  const prevValidateRef = useRef(false);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  useEffect(() => {
    setSelectedIndex(null);
    prevValidateRef.current = false;
  }, [question.id]);
  useEffect(() => {
    if (!shouldValidate) prevValidateRef.current = false;
  }, [shouldValidate]);
  useEffect(() => {
    onReadyChange?.(selectedIndex !== null);
  }, [selectedIndex, onReadyChange]);
  useEffect(() => {
    if (shouldValidate && !prevValidateRef.current && selectedIndex !== null) {
      prevValidateRef.current = true;
      onAnswer(String(selectedIndex));
    }
  }, [shouldValidate, selectedIndex, onAnswer]);
  const handleKeyDown = (e: React.KeyboardEvent, rowIndex: number) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setSelectedIndex(rowIndex);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      document.getElementById(`table-row-${(rowIndex + 1) % table.rows.length}`)?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      document.getElementById(`table-row-${(rowIndex - 1 + table.rows.length) % table.rows.length}`)?.focus();
    }
  };
  return <div className="w-full max-w-2xl mx-auto overflow-hidden rounded-xl border border-slate-200 shadow-sm" data-id="element-7407">
      <table className="w-full text-left border-collapse" role="grid" aria-label="Tabel met gegevens" data-id="element-7408">
        <thead data-id="element-7409">
          <tr className="bg-slate-50 border-b border-slate-200" role="row" data-id="element-7410">
            {table.headers.map((header: string, i: number) => <th key={i} className="p-4 font-bold text-slate-700" role="columnheader" data-id="element-7411">
                <LatexRenderer content={header} data-id="element-7412" />
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-7413">
          {table.rows.map((row: string[], rowIndex: number) => {
          const isSelected = selectedIndex === rowIndex;
          return <tr key={rowIndex} id={`table-row-${rowIndex}`} role="row" aria-selected={isSelected} tabIndex={0} onClick={() => setSelectedIndex(rowIndex)} onKeyDown={e => handleKeyDown(e, rowIndex)} className={`cursor-pointer transition-colors border-b border-slate-100 last:border-0 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 ${isSelected ? 'bg-indigo-50 text-indigo-900' : 'hover:bg-slate-50 text-slate-600'}`} data-id="element-7414">
                {row.map((cell: string, cellIndex: number) => <td key={cellIndex} className="p-4" role="gridcell" data-id="element-7415">
                    <LatexRenderer content={cell} data-id="element-7416" />
                  </td>)}
              </tr>;
        })}
        </tbody>
      </table>
      <div className="bg-slate-50 p-3 text-center text-sm text-slate-500 border-t border-slate-200" data-id="element-7417">
        Klik op een rij of gebruik de pijltjestoetsen
      </div>
    </div>;
}